<template>
  <base-menu id="menu-2" :menu-position="menuPosition"/>
</template>

<script>
import BaseMenu from "./BaseMenu";
import {MenuProps} from "./MenuProps";

export default {
  name: "Menu2",
  components: {BaseMenu},
  props: {
    ...MenuProps
  }
}
</script>

<style>
#menu-2 .base-menu-item-wrapper {
  margin: 15px 0;
}

#menu-2 .dropdown-item {
  text-align: center;
}
</style>